import styles from './Progress.module.css';

interface ProgressBarProps {
  /** 0–100. Только настоящее значение: выдуманные проценты запрещены (DS §8). */
  percent: number;
  /** Доступное имя: что именно прогрессирует. */
  label: string;
  /** Показать число рядом с полосой. */
  showValue?: boolean | undefined;
  className?: string | undefined;
}

/**
 * Полоса прогресса DESIGN_SYSTEM §6: заполненная часть — --color-accent,
 * дорожка — --color-border.
 * Заполнение анимируется через transform (width не анимируется никогда).
 */
export function ProgressBar({ percent, label, showValue = false, className }: ProgressBarProps) {
  const bounded = Math.max(0, Math.min(100, Math.round(percent)));

  return (
    <div className={[styles.barWrapper, className].filter(Boolean).join(' ')}>
      <div
        className={styles.track}
        role="progressbar"
        aria-label={label}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={bounded}
      >
        <div className={styles.fill} style={{ transform: `scaleX(${bounded / 100})` }} />
      </div>
      {showValue ? <span className={`${styles.value} tabular`}>{bounded} %</span> : null}
    </div>
  );
}
